'use client';

import { Button, Padding, Typography } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { BottomButtonWrapper } from '../../common/components/BottomButtonWrapper';
import { useDebounceCallback } from '../../common/hooks/useDebounceCallback';
import { curatorQueries } from '../../query-factory';
import type { NicknameForm } from './NicknameEditForm';
import { NICKNAME_VALIDATION_DEBOUNCE_DELAY } from './NicknameRecommendationInput';

interface Props {
  isLoading: boolean;
  handleSubmit: () => void;
  updateNicknameError: Error | null;
}

export const NicknameEditButton = ({ isLoading, handleSubmit, updateNicknameError }: Props) => {
  const {
    watch,
    formState: { isDirty, errors },
  } = useFormContext<NicknameForm>();
  const nickname = watch('nickname');
  const [debouncedNickname, setDebouncedNickname] = useState(nickname);

  // NOTE: 닉네임 디바운스 처리
  const debouncedSetNickname = useDebounceCallback((value: string) => {
    setDebouncedNickname(value);
  }, NICKNAME_VALIDATION_DEBOUNCE_DELAY);

  useEffect(() => {
    debouncedSetNickname(nickname);
  }, [nickname, debouncedSetNickname]);

  const { data: availableCountData } = useQuery({
    ...curatorQueries.profile.nicknameAvailableCount,
  });

  const isTyping = nickname !== debouncedNickname;

  const disabled =
    isLoading ||
    availableCountData?.remainingCount === 0 ||
    !isDirty ||
    !!updateNicknameError ||
    !!errors.nickname?.message ||
    isTyping;

  return (
    <BottomButtonWrapper>
      <Padding y="3">
        <Button
          size="44"
          className="w-full"
          variant="primary"
          onClick={handleSubmit}
          disabled={disabled}
          isLoading={isLoading}
          type="button"
        >
          <Typography size="14" weight="medium">
            변경하기
          </Typography>
        </Button>
      </Padding>
    </BottomButtonWrapper>
  );
};
